import { ExclamationIcon } from "../Icons";
import Modal from "../components/ModalWindow";

interface Props {
  isModalOpen: boolean;
  closeRemainderModal: () => void;
  firstName: string;
  lastNameFirstLetter: string;
  formattedFullName: string;
}

export function ReminderSentModal({
  isModalOpen,
  closeRemainderModal,
  firstName,
  lastNameFirstLetter,
  formattedFullName,
}: Props) {
  return (
    <Modal isOpen={isModalOpen} closeModal={closeRemainderModal}>
      <div>
        <div className="flex justify-end">
          <button className="rounded bg-white px-4 py-2" onClick={closeRemainderModal}>
            X
          </button>
        </div>
        <div className="pb-4">
          <div className="flex justify-center">
            <ExclamationIcon className="mr-2 h-8 w-8 text-warning" />
          </div>
          <label>
            The technical form has already been submitted, and it's now awaiting the vessel master's response.
          </label>
        </div>
        <div className="rounded-lg bg-success">
          <div className="grid grid-cols-3 gap-4 p-2">
            <div className="mb-4">
              <div className="block text-xs font-medium text-lightGrey">Request sent on</div>
              <div />
            </div>
            <div className="mb-4">
              <div className="block text-xs font-medium text-lightGrey">Vessel email</div>
              <div className="flex items-center">vessel@email.com</div>
            </div>
            <div className="mb-4">
              <div className="block text-xs font-medium text-lightGrey">Request by</div>

              <div>
                <span className="rounded-lg bg-white text-xs uppercase text-green">
                  {firstName}
                  {lastNameFirstLetter}
                </span>{" "}
                {formattedFullName}
              </div>
            </div>
          </div>
        </div>
        <footer className="flex justify-end p-4">
          <div className="grid grid-cols-2 gap-2">
            <button
              className="rounded border border-gray-300 bg-white px-4 py-2 text-green"
              onClick={closeRemainderModal}
            >
              Sent a reminder
            </button>
            <button className="rounded bg-green px-4 py-2 text-white" onClick={closeRemainderModal}>
              Close
            </button>
          </div>
        </footer>
      </div>
    </Modal>
  );
}
